import React, { memo, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

const DefaultLayout = ({ children }) => {
  const location = useLocation()

  return (
    <>
      {/* 页面 */}
      {children}
    </>
  )
}

export default memo(DefaultLayout)
